import React, { useState, useEffect } from 'react'
import { T, Spinner, Empty, Avatar, probColor, inGameFilter, playColor } from '../ui'
import { getNFLLocks } from '../api'
import { playText, teamNick } from '../plain'

// LOCKS — the "will it hit" lens. Plays ranked by pure LIKELIHOOD at the offered line (not edge),
// so a lock answers whether it's likely to cash, price aside. Honest: the % is P over the ACTUAL
// offered line, so a steep star line that's really a coin flip never shows up here as a lock.
export default function LocksTab({ season = 2026, week = 1, onPlayer, gameFilter, embedded }) {
  const [d, setD] = useState(null)
  useEffect(() => { let a = true; setD(null)
    getNFLLocks(season, week).then(r => { if (a) setD(r) }); return () => { a = false } }, [season, week])

  if (!d) return <Spinner />
  const rows = (d.locks || []).filter(r => inGameFilter(gameFilter, r.team))
  return (
    <div style={{ padding: embedded ? '0' : '10px 14px 80px' }}>
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderLeft: `3px solid ${T.green}`,
        borderRadius: 11, padding: '11px 13px', marginBottom: 12, fontSize: 12, color: T.muted2, lineHeight: 1.5 }}>
        <b style={{ color: T.green }}>Most likely to cash.</b> Ranked by <b style={{ color: T.text }}>pure likelihood</b> at
        the offered line — not price. This list answers <b style={{ color: T.text }}>“how likely is it to hit,”</b> not whether the price is good. Nothing here is a sure thing.
      </div>
      {rows.length === 0
        ? <Empty message="No locks yet — fills as the board and lines post." />
        : rows.map((r, i) => {
          const pct = Math.round((r.prob || 0) * 100)
          const what = r.prop_type === 'anytime_td' ? 'Anytime TD' : `${playText(r.market, r.line)}`
          return (
            <button key={i} onClick={() => onPlayer && onPlayer({ full_name: r.name, pos: r.pos, team: r.team,
              opp: r.opp, prop_type: r.prop_type, market: r.market, ...(r.gsis_id ? { gsis_id: r.gsis_id } : {}), status: 'active' })}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%',
                textAlign: 'left', cursor: 'pointer', background: T.card, border: `1px solid ${T.border}`,
                borderRadius: 11, padding: '12px 14px', marginBottom: 8, color: T.text }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 11, minWidth: 0 }}>
                <span style={{ fontFamily: T.mono, fontSize: 12, fontWeight: 800, color: T.faint, width: 18 }}>{i + 1}</span>
                <Avatar url={r.headshot} name={r.name} team={r.team} size={36} />
                <span style={{ minWidth: 0 }}>
                  <span style={{ display: 'block', fontSize: 15, fontWeight: 800 }}>{r.name}</span>
                  <span style={{ display: 'block', fontSize: 11.5, color: T.muted, fontWeight: 600 }}>
                    {teamNick(r.team)} vs {teamNick(r.opp)} · <b style={{ color: T.text }}>{what}</b></span>
                </span>
              </span>
              <span style={{ textAlign: 'right', flexShrink: 0 }}>
                <span style={{ display: 'block', fontFamily: T.mono, fontSize: 19, fontWeight: 900, color: playColor(r.prob || 0, r) }}>{pct}%</span>
                <span style={{ display: 'block', fontSize: 10, color: T.faint, fontWeight: 700 }}>to cash</span>
              </span>
            </button>
          )
        })}
      <div style={{ fontSize: 10, color: T.faint, marginTop: 10, lineHeight: 1.5 }}>
        % = the model's chance to clear the <b>offered</b> line · likelihood, not edge · informational only · 21+.
      </div>
    </div>
  )
}
